// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__minervaModern_7e0e95', '__minervaModern_Fallback_7e0e95'"},"className":"__className_7e0e95","variable":"__variable_7e0e95"};